import {
  SET_DESIGNER_CREDIT_PACKAGES,
  SET_DESIGNER_CREDIT_PACKAGES_LOADER,
  SET_DESIGNER_HISTORY_DATA,
  SET_DESIGNER_HISTORY_LOADER,
  CLEAR_DESIGNER_HISTORY_DATA,
  LOGOUT,
} from '~/redux/actions/action-types';

const initialHistory = {
  rows: [],
  count: 0,
  total: 0,
  perPage: 5,
  currentPage: 1,
  lastPage: 1,
  from: 0,
  to: 0,
};

const initialState = {
  creditPackages: [],
  packagesLoading: false,
  history: initialHistory,
  historyLoading: false,
};

const designerQueriesReducers = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_DESIGNER_CREDIT_PACKAGES:
      return {
        ...state,
        creditPackages: payload || [],
      };
    case SET_DESIGNER_CREDIT_PACKAGES_LOADER:
      return {
        ...state,
        packagesLoading: payload,
      };
    case SET_DESIGNER_HISTORY_DATA:
      return {
        ...state,
        history: {
          ...initialHistory,
          ...payload,
          rows: payload?.rows || [],
        },
      };
    case SET_DESIGNER_HISTORY_LOADER:
      return {
        ...state,
        historyLoading: payload,
      };
    case CLEAR_DESIGNER_HISTORY_DATA:
      return {
        ...state,
        history: initialHistory,
      };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export { designerQueriesReducers };
